export default function getCashTransactionsSum(transactions) {
  return transactions
    .map(transaction => {
      const multiplier = transaction.type === 1 ? 1 : -1;
      return Number(transaction.amount) * multiplier;
    })
    .reduce((total, amount) => total + amount, 0);
}
